import { ref } from "vue";
import Swal from "sweetalert2";
import i18n from "@/i18n/index";

import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";
import router from "@/router/index";
import {
  clubs,
  currentClub,
  clubUUID,
  userUUID,
  singleClub,
} from "@/shared/state";
import { Club, ClubResponse, ClubRequest } from "@/interfaces/club";

const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function useClub() {
  const errorClub = ref<boolean | false>(false);
  const isRequestClub = ref<boolean | false>(false);
  const getClubsByUser = async () => {
    try {
      isRequestClub.value = true;
      errorClub.value = false;
      clubs.data = [];
      const response = await authenticatedFetch(
        `${API_URL}clubs/user/${userUUID.value}`,
        {
          method: "GET",
        },
        false,
        "",
        false,
      );
      clubs.data = response?.data || [];
      isRequestClub.value = false;
    } catch (err: any) {
      errorClub.value = true;
      isRequestClub.value = false;
    }
  };

  const getClubs = async () => {
    try {
      isRequestClub.value = true;
      errorClub.value = false;
      clubs.data = [];
      const response = await authenticatedFetch(
        `${API_URL}clubs/${userUUID.value}`,
        {
          method: "GET",
        },
        false,
        "",
        false,
      );
      clubs.data = response?.data || [];
      isRequestClub.value = false;
    } catch (err: any) {
      errorClub.value = true;
      isRequestClub.value = false;
    }
  };

  const getDetailsClub = async (clubUUID: string) => {
    try {
      isRequestClub.value = true;
      errorClub.value = false;
      singleClub.data = null;
      const response = await authenticatedFetch(
        `${API_URL}clubs/details/${clubUUID}/${userUUID.value}`,
        {
          method: "GET",
        },
        false,
        "",
        false,
      );
      singleClub.data = response?.data || [];
      isRequestClub.value = false;
    } catch (err: any) {
      errorClub.value = true;
      isRequestClub.value = false;
    }
  };

  const addClub = async (body: ClubRequest) => {
    try {
      isRequestClub.value = true;
      errorClub.value = false;
      const response = await authenticatedFetch(
        `${API_URL}clubs/store/${userUUID.value}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response) {
        if (response?.url) {
          // Open PDF in a new tab
          window.open(response?.url, "_blank");
          router.push({
            name: "club-created-success",
            params: { userUUID: userUUID.value },
          });

          //   window.location.href = response?.url
        }
      }
      isRequestClub.value = false;
    } catch (err: any) {
      errorClub.value = true;
      isRequestClub.value = false;
    }
  };

  const renewSubscription = async (body) => {
    try {
      isRequestClub.value = true;
      errorClub.value = false;
      const response = await authenticatedFetch(
        `${API_URL}clubs/renew-subscription`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response) {
        if (response?.url) {
          // Open PDF in a new tab
          window.open(response?.url, "_blank");
          router.push({
            name: "club-created-success",
            params: { userUUID: body.userUUID },
          });
        }
      }
      isRequestClub.value = false;
    } catch (err: any) {
      errorClub.value = true;
      isRequestClub.value = false;
    }
  };

  const editClub = async (body: ClubRequest) => {
    try {
      isRequestClub.value = true;
      errorClub.value = false;
      const response = await authenticatedFetch(
        `${API_URL}clubs/edit/${body?.id}/${userUUID.value}`,
        {
          method: "PUT",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response) {
        const clubEdited: Club = response?.data;
        const index = clubs?.data?.findIndex(
          (club) => club?.id === clubEdited?.id,
        );
        if (index !== -1) {
          clubs.data[index] = clubEdited;
        }
      }
      isRequestClub.value = false;
    } catch (err: any) {
      errorClub.value = true;
      isRequestClub.value = false;
    }
  };

  const deleteClub = async (id: number) => {
    try {
      isRequestClub.value = true;
      errorClub.value = false;
      const response = await authenticatedFetch(
        `${API_URL}clubs/delete/${id}/${userUUID.value}`,
        {
          method: "DELETE",
        },
        true,
        "",
        true,
      );
      const index = clubs?.data?.findIndex((club) => club?.id === id);
      if (index !== -1) {
        clubs.data.splice(index, 1);
      }
      isRequestClub.value = false;
    } catch (err: any) {
      errorClub.value = true;
      isRequestClub.value = false;
    }
  };

  const intClubUUID = async (club: Club) => {
    clubUUID.value = club?.uuid || "";
    if (club) {
      initialValuesClub(club);
    }
    localStorage.setItem("selectedClub", JSON.stringify(club));
    router.push({
      name: "access-rapide",
      params: { clubUUID: clubUUID.value },
    });
  };
  const switchClub = async () => {
    initialValuesClub(null);
    localStorage.removeItem("selectedClub");
    router.push({ name: "list-clubs", params: { userUUID: userUUID.value } });
  };

  const initialValuesClub = (club: Club | null) => {
    currentClub.value.id = club?.id ?? null;
    currentClub.value.name = club?.name ?? null;
    currentClub.value.country = club?.country ?? null;
    currentClub.value.city = club?.city ?? null;
    currentClub.value.address = club?.address ?? null;
    currentClub.value.phone = club?.phone ?? null;
    currentClub.value.city = club?.city ?? null;
    currentClub.value.accountStripe = club?.accountStripe ?? null;
    currentClub.value.ice = club?.ice ?? null;
    currentClub.value.url = club?.url ?? null;
    currentClub.value.slug = club?.slug ?? null;
    currentClub.value.user_id = club?.user_id ?? null;
    currentClub.value.path_logo =
      club?.path_logo ?? null;
    currentClub.value.path_signature =
      club?.path_signature ?? null;
    currentClub.value.uuid = club?.uuid ?? null;
    currentClub.value.subscriptions = club?.subscriptions ?? null;
    currentClub.value.active_subscription = club?.active_subscription ?? null;
    currentClub.value.raspberry_url = club?.raspberry_url ?? null;
    currentClub.value.whatsapp_wallet = club?.whatsapp_wallet ?? null;

    if (currentClub?.value?.active_subscription?.status) {
      if (
        currentClub?.value?.active_subscription?.status?.remaining_days <= 4
      ) {
        const day =
          currentClub?.value?.active_subscription?.status?.remaining_days +
          " " +
          i18n.t("symbole.day");
        Swal.fire({
          title: i18n.t("views.clients.club.expiring_club.title", {
            day: day + "s",
          }),
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: i18n.t("button.ok"),
          allowOutsideClick: false, // ✅ disable closing by clicking outside
          allowEscapeKey: false, // (optional) disable closing with ESC
        });
      }
    }
  };

  const paymentStatus = async (body) => {
    try {
      isRequestClub.value = true;
      errorClub.value = false;
      const response = await authenticatedFetch(
        `${API_URL}clubs/payment`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response) {
        isRequestClub.value = false;
        return response;
      }
      isRequestClub.value = false;
    } catch (err: any) {
      errorClub.value = true;
      isRequestClub.value = false;
    }
  };

  const createPaymentLink = async (body) => {
    try {
      isRequestClub.value = true;
      errorClub.value = false;
      const response = await authenticatedFetch(
        `${API_URL}clubs/create-payment-link`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response?.url) {
        isRequestClub.value = false;
        window.open(response?.url, "_blank");
        //window.location.href = response?.url
      }
      isRequestClub.value = false;
    } catch (err: any) {
      errorClub.value = true;
      isRequestClub.value = false;
    }
  };

  const intSettingClub = async (club: Club) => {
    clubUUID.value = club?.uuid || "";
    if (club) {
      initialValuesClub(club);
    }
    localStorage.setItem("selectedClub", JSON.stringify(club));
    router.push({ name: "users", params: { userUUID: userUUID.value } });
  };

  const checkExpressPayement = async (body) => {
    try {
      isRequestClub.value = true;
      errorClub.value = false;
      const response = await authenticatedFetch(
        `${API_URL}clubs/check-express-payement`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        false,
      );
      if (response) {
        isRequestClub.value = false;
        return response;
      }
      isRequestClub.value = false;
    } catch (err: any) {
      errorClub.value = true;
      isRequestClub.value = false;
    }
  };

  return {
    checkExpressPayement,
    getClubsByUser,
    getClubs,
    addClub,
    editClub,
    deleteClub,
    intClubUUID,
    intSettingClub,
    switchClub,
    initialValuesClub,
    paymentStatus,
    createPaymentLink,
    renewSubscription,
    getDetailsClub,
    isRequestClub,
    errorClub,
  };
}
